import Table from "@mui/material/Table";
import Body from "@mui/material/TableBody";
import Cell from "@mui/material/TableCell";
import Container from "@mui/material/TableContainer";
import Head from "@mui/material/TableHead";
import Row from "@mui/material/TableRow";
export default {
    Body,
    Cell,
    Container,
    Head,
    Table,
    Row,
};
//# sourceMappingURL=Table.js.map